import otherApi from '@/api/other'
import store from '@/store/store'

const app = {
  state: {
    system: store.getSystem(),
    app: [],
    appId: store.getOtherAppId()
  },
  getters: {
    app: state => state.app,
    appId: state => state.appId,
    system: state => state.system
  },
  mutations: {
    SET_SYSTEM: (state, system) => {
      store.setSystem(system)
      state.system = system
    },
    SET_APP: (state, app) => {
      state.app = app
    },
    SET_OTHER_APP_ID: (state, appId) => {
      state.appId = appId
    }
  },
  actions: {
    GetApp ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 区别国内/海外
        let getAppData = otherApi.getAppData
        let getAppId = store.getOtherAppId
        let setAppId = store.setOtherAppId
        getAppData().then(res => {
          commit('SET_APP', res)
          let appId = getAppId()
          if (!appId) {
            appId = res[res.length - 1].id
          }
          commit('SET_OTHER_APP_ID', Number(appId))
          setAppId(appId)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ChangeApp ({ commit, state }, appId) {
      return new Promise((resolve, reject) => {
        commit('SET_OTHER_APP_ID', appId)
        store.setOtherAppId(appId)
        resolve()
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js